import React, { Component } from "react";
import logo from "../../assets/images/ToyotaLogo.jpg";
import { Link } from "react-router-dom";
import "./ShipmentHeader.css";
class ShipmentHeader extends Component {
  render() {
    console.log("props invoice header:", this.props);
    return (
      <div className="headbar">
        <div className="row">
          <div className="col-md-2 col-sm-3 col-xs-3">
            <img
              src={logo}
              alt=""
              style={{ top: "10px", position: "absolute", width: "44%" }}
            />
          </div>
          <div
            className="col-md-4 col-sm-1 col-xs-1  "
            style={{ textAlign: "left" }}
          >
            <h2
              className="labelmargintop"
              style={{
                fontSize: "140%",
                color: "#428bca",
                marginRight: "100px",
                height: "3rem",
              }}
            >
              {this.props.page}
            </h2>
          </div>
          <div
            className="col-md-2 col-sm-2 col-xs-3"
            style={{ marginTop: "10px", textAlign: "left" }}
          >
            <span
              style={{
                position: "relative",
                fontSize: "12px",
                fontWeight: "bold",
                textAlign: "left",
                marginRight: "100px",
              }}
            >
              {this.props.username}
            </span>
          </div>
          {this.props.roles.includes("EDOC TME USER") ||
          this.props.roles.includes("EDOC NMSC USER") ||
          this.props.roles.includes("EDOC TME AF USER") ? (
            <div
              className="col-md-1 col-sm-2 col-xs-2 labelmargintop"
              style={{ textAlign: "left" }}
            >
              <Link to="/invoiceSearch">
                <span style={{ color: "white" }}>
                  <button
                    className="btn btn-danger btn-circle pull-right"
                    style={{
                      marginTop: "10px",
                      height: "2.9rem",
                    }}
                  >
                    Invoice
                  </button>
                </span>
              </Link>
            </div>
          ) : (
            <div className="col-md-1 col-sm-1 col-xs-1"></div>
          )}

          {this.props.roles.includes("EDOC VLG TME USER") ||
          this.props.roles.includes("EDOC TME AF USER") ||
          this.props.roles.includes("EDOC VLG NMSC USER") ? (
            <div
              className="col-md-1 col-sm-2 col-xs-2 labelmargintop"
              style={{ textAlign: "left" }}
            >
              <Link to="/salesInvoice">
                <span style={{ color: "white" }}>
                  <button
                    className="btn btn-danger btn-circle pull-right"
                    style={{
                      marginTop: "10px",
                      marginLeft: "90px",
                      height: "2.9rem",
                    }}
                  >
                    Vehicle Sales
                  </button>
                </span>
              </Link>
            </div>
          ) : (
            <div className="col-md-1 col-sm-1 col-xs-1"></div>
          )}

          {this.props.roles.includes("EDOC PSCG ADMIN") ? (
            <div
              className="col-md-1 col-sm-2 col-xs-2 labelmargintop"
              style={{ textAlign: "left" }}
            >
              <Link to="/pscgInvoicingSystem">
                <span style={{ color: "white" }}>
                  <button
                    className="btn btn-danger btn-circle pull-right"
                    style={{
                      marginTop: "10px",
                      marginLeft: "90px",
                      height: "2.9rem",
                    }}
                  >
                    TME ADMIN
                  </button>
                </span>
              </Link>
            </div>
          ) : (
            <div className="col-md-1 col-sm-1 col-xs-1"></div>
          )}

          <div
            className="col-md-1 col-sm-2 col-xs-2 labelmargintop"
            style={{ textAlign: "left" }}
          >
            <button
              className="btn btn-danger btn-circle"
              style={{ marginTop: "10px", height: "2.9rem" }}
              onClick={this.props.logoutUser}
            >
              <i
                className="fa fa-sign-out"
                aria-hidden="true"
                style={{ marginLeft: "1px" }}
              ></i>
              LogOut
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ShipmentHeader;
